import { render } from "./xjmanage.vue?vue&type=template&id=090444ae&scoped=true"
import script from "./xjmanage.vue?vue&type=script&lang=js"
export * from "./xjmanage.vue?vue&type=script&lang=js"

import "./xjmanage.vue?vue&type=style&index=0&id=090444ae&lang=scss&scoped=true"
import "./xjmanage.vue?vue&type=style&index=1&id=090444ae&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090444ae"]])

export default __exports__